import React from 'react';
import { Dialog } from '@ygtechnologies/rubus-ui';
import { LoadingIndicator, DateTimeDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { useAsyncState } from '@/utils/hooks';
import {
    getOutgoingEmail,
    getOutgoingEmailAttachmentUrl,
    getOutgoingEmailBodyUrl,
} from '@/services/communicore';
import { AttachmentList, DetailList, SendAttemptsTable } from './shared';
import theme from './Communicore.module.scss';

interface OutgoingEmailDetailsModalProps {
    id: string;
    onClose(): void;
}

const OutgoingEmailDetailsModal: React.FC<OutgoingEmailDetailsModalProps> = ({ id, onClose }) => {
    const [email] = useAsyncState(() => getOutgoingEmail(id), [id], null);

    return (
        <Dialog open onOpenChange={(open) => !open && onClose()}>
            <Dialog.Content contentWidth="md">
                <Dialog.Header>Outgoing email</Dialog.Header>
                {!email ? (
                    <LoadingIndicator />
                ) : (
                    <div>
                        <DetailList
                            items={[
                                { label: 'Created', value: <DateTimeDisplay value={email.createdAt} /> },
                                { label: 'To', value: email.to.join(', ') },
                                { label: 'Cc', value: email.cc.join(', ') },
                                { label: 'Bcc', value: email.bcc.join(', ') },
                                { label: 'Subject', value: email.subject },
                                { label: 'Status', value: email.status },
                                {
                                    label: 'Sent',
                                    value: email.sendTime && <DateTimeDisplay value={email.sendTime} />,
                                },
                                { label: 'Attempts', value: `${email.attemptCount} / ${email.maxAttempts}` },
                                { label: 'Id', value: email.id },
                                { label: 'AWS email id', value: email.awsEmailId },
                            ]}
                        />

                        <h4 className={theme.sectionHeader}>Body</h4>
                        {email.body ? (
                            <iframe title="Email body" sandbox="" className={theme.bodyFrame} src={getOutgoingEmailBodyUrl(email.id)} />
                        ) : (
                            <p>No body stored.</p>
                        )}

                        <h4 className={theme.sectionHeader}>Attachments</h4>
                        <AttachmentList
                            attachments={email.attachments}
                            getUrl={(fileId) => getOutgoingEmailAttachmentUrl(email.id, fileId)}
                        />

                        <h4 className={theme.sectionHeader}>Send attempts</h4>
                        <SendAttemptsTable attempts={email.sendAttempts} />
                    </div>
                )}
            </Dialog.Content>
        </Dialog>
    );
};

export default OutgoingEmailDetailsModal;
